import React from "react";
import ErrorFallback from "./ErrorFallback";
import { logFrontendError } from "../../services/errorLogger";

class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, errorInfo) {
    logFrontendError({
      message: error.message,
      stack: error.stack,
      componentStack:
        errorInfo.componentStack,
    });
  }

  reset = () => {
    this.setState({
      hasError: false,
      error: null,
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          error={this.state.error}
          reset={this.reset}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;